export function isPersonalEmailDomain(input: string): boolean {
  if (!input) return false;

  // Extract domain if full email was provided
  const domain = input.includes('@')
    ? input.split('@').pop()!.toLowerCase().trim()
    : input.toLowerCase().trim();

  const personalDomains = new Set<string>([
    // Major global providers
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'live.com',
    'msn.com',
    'icloud.com',
    'me.com',
    'mac.com',
    'aol.com',

    // Privacy-focused
    'proton.me',
    'protonmail.com',
    'tutanota.com',
    'tutamail.com',
    'mailbox.org',
    'posteo.net',

    // Other common providers
    'gmx.com',
    'gmx.net',
    'mail.com',
    'yandex.com',
    'yandex.ru',
    'zoho.com',

    // Regional high-volume
    'qq.com',
    '163.com',
    '126.com',
    'naver.com',
    'daum.net',
    'web.de',
    'orange.fr',
    'libero.it',
    'bol.com.br',
  ]);

  return personalDomains.has(domain);
}
